import { render, staticRenderFns } from "./DateBox.vue?vue&type=template&id=858137f4"
import script from "./DateBox.vue?vue&type=script&lang=js"
export * from "./DateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports